import { useEffect, useRef } from 'react';
import { Location, NavigateFunction } from 'react-router-dom';

import { CandidateAiReviewStateType } from '../candidates/Candidates.types';

type UseStartCandidateAiRefreshOnNavigationProps = {
  candidateId?: string;
  location: Pick<Location, 'pathname' | 'search' | 'hash'>;
  navigate: NavigateFunction;
  refetchAiReviewState: () => Promise<unknown>;
  resolvedAiReviewState?: CandidateAiReviewStateType;
  shouldStartAiRefreshOnLoad: boolean;
  startCandidateAiRefreshSession: (aiReviewState: CandidateAiReviewStateType) => void;
};

export const useStartCandidateAiRefreshOnNavigation = ({
  candidateId,
  location,
  navigate,
  refetchAiReviewState,
  resolvedAiReviewState,
  shouldStartAiRefreshOnLoad,
  startCandidateAiRefreshSession,
}: UseStartCandidateAiRefreshOnNavigationProps) => {
  const hasStartedAiRefreshOnLoadRef = useRef(false);

  useEffect(() => {
    hasStartedAiRefreshOnLoadRef.current = false;
  }, [candidateId]);

  useEffect(() => {
    if (
      !shouldStartAiRefreshOnLoad ||
      !candidateId ||
      !resolvedAiReviewState ||
      resolvedAiReviewState.cvProcessing.canProcess === false ||
      hasStartedAiRefreshOnLoadRef.current
    ) {
      return;
    }

    hasStartedAiRefreshOnLoadRef.current = true;
    startCandidateAiRefreshSession(resolvedAiReviewState);
    void refetchAiReviewState();
    navigate(
      {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
      },
      { replace: true, state: null }
    );
  }, [
    candidateId,
    location.hash,
    location.pathname,
    location.search,
    navigate,
    refetchAiReviewState,
    resolvedAiReviewState,
    shouldStartAiRefreshOnLoad,
    startCandidateAiRefreshSession,
  ]);
};
